<template>
  <div>
    <DynamicRender
      v-if="loaded && (widgetsData && widgetsComputedReady && controlInfo)"
      :template="controlInfo.customCode || ''"
      :data="widgetsData"
      :computed="widgetsComputedReady"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import DynamicRender from '@/components/DynamicRender'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cell',
    'options',
    'gridId',
    'widgetKey',
    'displayType',
    'controlInfo',
    'dInst',
  ],
  components: {
    DynamicRender,
  },
  data() {
    return {
      widgetsData: null,
      widgetsComputedReady: null,
      loaded: false,
    }
  },
  computed: {
    ...mapState(['currentDash']),
  },
  methods: {
    updateCell() {
      this.loaded = false
      this.widgetsData.rowData = $dataGrid(this.gridId)[this.rowKey]
      setTimeout(() => {
        this.loaded = true
      }, 100)
    },
  },
  created() {
    this.widgetsData = Object.assign(
      { control: this.controlInfo },
      this.dInst.widgetsData
    )
    this.widgetsComputedReady = this.dInst.widgetsComputedReady

    this.widgetsData.rowData = $dataGrid(this.gridId)[this.rowKey]
    eventBus.$on(`dgRowUpdated-${this.gridId}`, this.updateCell)
    this.widgetsData.gridId = this.gridId
    this.widgetsData.rowKey = this.rowKey

    this.loaded = true
  },
  beforeDestroy() {
    eventBus.$off(`dgRowUpdated-${this.gridId}`, this.updateCell)

    this.widgetsData = null
    this.widgetsComputedReady = null
    this.loaded = null
  }
}
</script>
